<template>
  <div class="mt-6">
    <v-row
      no-gutters
      align="center"
    >
      <div class="text-h6">Аналитика</div>
      <v-btn
        icon
        class="ml-2"
        @click="$emit('refreshAnalytics')"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-row>

    <div class="mb-4">
      <div class="text-subtitle-1 font-weight-medium mb-2">Доставка PUSH уведомлений</div>
      <div class="ml-2">
        <div class="d-flex align-center">
          <div class="text-body-1">Процент доставки:</div>
          <div class="ml-2">{{ getDeliveryPercentage }}%</div>
        </div>
        <div class="d-flex align-center">
          <div class="text-body-1">Кол-во пользователей:</div>
          <div class="ml-2">{{ analytics.users_who_received_push }}</div>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <div class="text-subtitle-1 font-weight-medium mb-2">Обработка уведомлений</div>
      <div class="ml-2">
        <div class="d-flex align-center">
          <div class="text-body-1">Кол-во обработанных:</div>
          <div class="ml-2">{{ analytics.completed_pushes }}</div>
        </div>
        <div class="d-flex align-center">
          <div class="text-body-1">Общее кол-во:</div>
          <div class="ml-2">{{ analytics.total_pushes }}</div>
        </div>
      </div>
    </div>

    <div>
      <div class="text-subtitle-1 font-weight-medium mb-2">Прочтение уведомлений</div>
      <div class="ml-2">
        <div class="d-flex align-center">
          <div class="text-body-1">Кол-во прочитанных:</div>
          <div class="ml-2">{{ analytics.total_read }}</div>
        </div>
        <div class="d-flex align-center">
          <div class="text-body-1">% перехода в приложение:</div>
          <div class="ml-2">{{ getReadPercentage }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'PushAnalytics',
    emits: ['refreshAnalytics'],
    props: {
      analytics: {
        type: Object,
        required: true,
        default: () => ({
          total_pushes: 0,
          completed_pushes: 0,
          read_from_push: 0,
          total_read: 0,
          users_who_received_push: 0,
          total_delivered_pushes: 0
        })
      }
    },
    computed: {
      getDeliveryPercentage() {
        if (!this.analytics.total_pushes) return 0
        return Math.round(
          (this.analytics.total_delivered_pushes / this.analytics.total_pushes) * 100
        )
      },
      getReadPercentage() {
        if (!this.analytics.total_delivered_pushes) return 0
        return Math.round((this.analytics.total_read / this.analytics.total_delivered_pushes) * 100)
      }
    }
  })
</script>
